/**
 * 关键词表格组件
 * 展示折线图数据：Date, Keyword, Mentions
 */
import React, { useMemo, useState } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import { DBO_V } from '@op/utils/format';
import useLanguage from '@op/hooks/useLanguage';
import type { TRequestBackType } from '@op/utils/requestUtil';
import { SortBy } from 'tea-component/lib/table/addons';
interface IKeywordTableChartProps {
  data: TRequestBackType;
  height?: number;
  getKeywordName: (keyword: string) => string;
}

const KeywordTableChart: React.FC<IKeywordTableChartProps> = ({
  data,
  height = 350,
  getKeywordName,
}) => {
  const { formatMessage } = useLanguage();
  const sortState = useState<SortBy<any>>({ by: 'time', order: 'desc' });

  // 表格列配置
  const columns = useMemo(
    () => [
      {
        key: 'time',
        header: formatMessage({ id: 'Date' }),
        width: 120,
      },
      {
        key: 'key',
        header: formatMessage({ id: 'Keyword' }),
        render: (data: any) => getKeywordName(data.key),
      },
      {
        key: 'value',
        header: formatMessage({ id: 'Mentions' }),
        render: ({ value }: { value: number }) => DBO_V.reviews(value),
      },
    ],
    [getKeywordName],
  );

  // 直接使用 tableRecord 数据
  const records = data?.tableRecord || [];

  return (
    <TableCommonHook
      className="dbo-keyword-analysis__table"
      recordKey={(record: any, index: number) =>
        `${record.time}-${record.key}-${index}`
      }
      columns={columns}
      records={records}
      hasPageable={false}
      maxHeight={height}
      minWidth={700}
      sortType="local"
      sortColumns={['time', 'value']}
      sortInfo={sortState}
    />
  );
};

export default KeywordTableChart;
